export default {
  geolocation: {
    lat: '42.698334',
    lng: '23.319941',
    label: '1001 Sofia',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
